
















import { DateTime } from 'luxon';
import { APP_UPDATE_DATE_RANGE } from '@/store/mutypes';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { Setting, AppState, DateRange } from '@/types';

@Component({ name: 'date-range-picker' })
export default class DateRangePicker extends Vue {
  @Prop({
    type: Array,
    default() {
      return ['since', 'until'];
    }
  })
  name!: string[];

  @Getter
  private getSetting!: (key: string) => any;
  @State(state => state.AppMod.dateRange)
  private dateRangeState!: DateRange;

  private pickerOptions: object = {
    shortcuts: [
      {
        text: 'Last week',
        onClick(picker: Vue) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: 'Last month',
        onClick(picker: Vue) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: 'Last 3 months',
        onClick(picker: Vue) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }
    ]
  };

  get dateRange(): Array<Date> {
    const range = this.dateRangeState;
    return range.map(dateTime => {
      const localTime = dateTime.toLocal();
      return localTime
        .plus({ minutes: dateTime.offset - localTime.offset })
        .toJSDate();
    });
  }

  set dateRange(value: Array<Date>) {
    let [since, until] = value;
    const sinceTime = DateTime.fromJSDate(since).set({
      hour: 0,
      minute: 0,
      second: 0
    });

    const untilTime = DateTime.fromJSDate(until).set({
      hour: 23,
      minute: 59,
      second: 59
    });

    this.$store.commit(APP_UPDATE_DATE_RANGE, [sinceTime, untilTime]);
  }
}
